import type { HttpError } from "@/utils/api"
import { httpClient, toHttpError } from "@/utils/api"
import { useQuery } from "@tanstack/react-query"
import type { UseQueryOptions } from "@tanstack/react-query"

interface UsageUnitsResponse {
  data: {
    attributes: {
      name: string
    }
  }[]
}

const getBillUsageUnits = async (): Promise<string[]> => {
  try {
    const response = await httpClient.get<UsageUnitsResponse>(
      "/api/v1/usage_units"
    )
    return response.data.data.map((item) => item.attributes.name)
  } catch (error: unknown) {
    throw toHttpError(error)
  }
}

export const useBillUsageUnits = (
  queryOptions: Omit<
    UseQueryOptions<string[], HttpError>,
    "queryFn" | "queryKey"
  > = {}
) => {
  const queryResult = useQuery<string[], HttpError>({
    gcTime: Infinity,
    staleTime: Infinity,
    ...queryOptions,
    queryFn: getBillUsageUnits,
    queryKey: ["bills", "usageUnits"],
  })

  return {
    ...queryResult,
    usageUnitsData: queryResult.data ?? [],
    usageUnitsIsFetching: queryResult.isFetching,
  }
}
